import './Reports.scss'
import * as React from 'react'
import classnames from 'classnames'
import { inject, observer } from 'mobx-react'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import NoReports from './components/no-reports/NoReports'
import ReportsList from './components/reports-list/ReportsList'
import ReportsHeader from './components/reports-header/ReportsHeader'
import { Grid } from '@tfo/common'
import RootStore from '../../../../stores/RootStore'
import { useEffect } from 'react'

export interface ReportsProps {
	rootStore?: RootStore
}

const Reports: React.FunctionComponent<ReportsProps &
	WrappedComponentProps> = props => {
		const store = props.rootStore!.clientViewStore!
		useEffect(() => {
			setReportStore()
		}, [])

		const setReportStore = async () => {
			await store.setReportStore()
		}

		return (
			<>
				{
					store.reportsStore &&
					< div
						className={
							classnames(
								'ClientView',
								'ClientView--lessTopMargin',
								'Reports',
								{
									'Reports--empty': !store.reportsStore.currentSectionHasOrders && !store.loading
								},
							)}>
						<Grid.GridWrapper>
							<ReportsHeader />
							<NoReports />
						</Grid.GridWrapper>
						<Grid.GridWrapper className={'ReportsList__Wrapper'}>
							<ReportsList />
						</Grid.GridWrapper>
					</div >
				}
			</>
		)
	}

export default inject('rootStore')(injectIntl(observer(Reports)))
